import { ROUTES_EVENT, ROUTES_EVENT_ATTENDANCE, ROUTES_EVENT_OVERVIEW, ROUTES_SWITCH_CLUB } from '@/constants/routes';
import store from '@/store';
import { i18n } from '@/lang';
import { guardRoute } from '@/router';

export default {
    path: '/event',
    name: ROUTES_EVENT,
    component: () => import(/*webpackChunkName: 'event'*/ '@/views/Event'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/event/:sessionId',
            name: ROUTES_EVENT_OVERVIEW,
            beforeEnter: guardRouteEvent,
            component: () => import(/*webpackChunkName: 'event'*/ '@/components/event/Event')
        },
        {
            path: '/event/attendance/:sessionId',
            name: ROUTES_EVENT_ATTENDANCE,
            beforeEnter: guardRouteEvent,
            component: () => import(/*webpackChunkName: 'event'*/ '@/components/session/attendance/Attendance')
        }
    ]
};

function guardRouteEvent(to, from, next) {
    checkEvent(to, from, next);
}

function checkEvent(to, from, next) {
    store
        .dispatch('sessionDetails/getEventDetails', {
            id: Number(to.params.sessionId)
        })
        .then(({ data }) => {
            const belongsToAnotherClub = data.club_id !== store.getters.selectedClubId;
            if (belongsToAnotherClub) {
                store.dispatch('notifyError', { message: i18n.t('thisEventBelongsToAnotherClub') });
                next({ name: ROUTES_SWITCH_CLUB, params: { clubId: data.club_id } });
            } else {
                store.commit('sessionDetails/sessionSave', data);
                guardRoute(next);
            }
        })
        .catch(error => {
            store.dispatch('notifyError', error);
            guardRoute(next, true);
        });
}
